import { useAdminGetExamRoomByIdQuery, type Room } from '@exam-center/graphql';
import { Loading } from '@shared/components';
import { createContext, type PropsWithChildren } from 'react';

interface AdminExamLocationDetailContextValue {
  examRoomInfo: Room;
}

export const AdminExamLocationDetailContext = createContext<
  AdminExamLocationDetailContextValue | undefined
>(undefined);

interface AdminExamLocationDetailProviderProps extends PropsWithChildren {
  children: React.ReactNode;
  examRoomId: string;
}

export default function AdminExamLocationDetailProvider(
  props: Readonly<AdminExamLocationDetailProviderProps>,
) {
  const { children, examRoomId } = props;

  const { data: roomData, loading } = useAdminGetExamRoomByIdQuery({
    variables: {
      getExamRoomByIdInput: {
        id: examRoomId,
      },
    },
  });
  if (loading) {
    return <Loading sx={{ height: '100dvh' }} />;
  }

  const examRoom = roomData?.ecAdminGetExamRoomById.examRoom;
  if (!examRoom) {
    return null;
  }
  const contextValue: AdminExamLocationDetailContextValue = {
    examRoomInfo: examRoom as Room,
  };

  return (
    <AdminExamLocationDetailContext.Provider value={contextValue}>
      {children}
    </AdminExamLocationDetailContext.Provider>
  );
}
